export default __webpack_public_path__ + "static/media/entrance.46e8cdc9.svg";